import {generatePath} from "react-router";
import {routes} from "../../routing/routes";
import type {RouteKey} from "../../routing/routes";
import type {FixLink} from "./briefingTypes";

/**
 * Maps the fixture's fix targets (route_registry) onto the pages that actually
 * exist in this app. Targets without an owning page in the showcase build render
 * without a navigation affordance.
 */
const FIX_TARGET_ROUTES: Record<string, RouteKey | null> = {
    supplier_normalization: 'cleanup_supplier_normalization',
    categorization: 'cleanup_categorization',
    contract_links: 'contract_linkage',
    contract_record: 'contract_linkage',
    rate_cards: 'analytics_koi_ppv',
    transaction_explorer: 'analytics_dashboard',
    policy_library: null,
    preferred_panel: null,
    demand_plan: null, // owner-routed (Ask owner), no page for the category manager
    supplier_risk: null, // owner-routed
    assumptions: null, // edited in place on the briefing
    foundation_worklist: null,
};

/**
 * Resolve a fix link to a real in-app path (with the fixture's record filter and a
 * return pointer back to this briefing), or null when the owning page is not part
 * of this build.
 */
export function resolveFixPath(fix: FixLink, databagId: number | undefined, returnPath: string): string | null {
    const routeKey = FIX_TARGET_ROUTES[fix.target];
    if (!routeKey || !databagId) return null;

    const base = generatePath(routes[routeKey], {id: String(databagId)});
    const fixtureQuery = fix.route.split('?')[1] ?? '';
    const params = new URLSearchParams(fixtureQuery);
    params.set('return', returnPath);
    const query = params.toString();
    return query ? `${base}?${query}` : base;
}
